module.exports = __webpack_public_path__ + "static/media/thumbnail.042eaaf6.jpg";